import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburger = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 25V26C11 27.657 12.343 29 14 29H26C27.657 29 29 27.657 29 26V25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 16C11 12.134 14.134 9 18 9H22C25.866 9 29 12.134 29 16",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 20H11C9.9 20 9 19.1 9 18C9 16.9 9.9 16 11 16H29C30.1 16 31 16.9 31 18C31 19.1 30.1 20 29 20H27L24 23L21 20Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 20C10.1 20 9 21.1 9 22.5C9 23.9 10.1 25 11.5 25H28.5C29.9 25 31 23.9 31 22.5C31 21.1 29.9 20 28.5 20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgHamburger);
export default ForwardRef;
